// Базовый URL бэкенд-API
// Можно переопределить через переменную окружения REACT_APP_API_URL
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
